import {
  checkDefined,
  CommonConstants
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import { Configs } from '../models/aem/overview.interface';
import { CommonRequest } from '../models/api/tracker.interfaces';

export const getServiceConfiguration = (configs: Configs): CommonRequest => {
  try {
    return {
      carrierCode: checkDefined(configs.carrierCode),
      timeout: configs.timeout || CommonConstants.TIMEOUT,
      retry: configs.retry || 0
    };
  } catch (error) {
    logError(
      error as Error,
      'SKYMILES',
      'SHARED',
      'SHARED_SERVICE_CONFIGURATION'
    );
    return {} as CommonRequest;
  }
};
